// import './App.css';
// import Bucket from './components/Bucket';
// import NavLeft from './shades/NavLeft';
// import TopBar from './shades/topBar';
// import { useEffect, useState } from 'react';
// import { Outlet } from "react-router-dom";

// import Card from "./shades/cards/BucketInner";

// function App() {
//   const [isOpen, setIsopen] = useState(true);
//   const ToggleBtn = () => {
//     isOpen === true ? setIsopen(false) : setIsopen(true);
//   }
//   useEffect(()=>{
//     setIsopen(isOpen);
//   },[isOpen])

//   return (
//     <div className='parentDiv '>
//       <TopBar ToggleBtn = {ToggleBtn} />
//       <div className='flex'>
//         <div className= {` bg-[#FAFAFA] pb-4 sidebar dark:bg-[#0A1D42] leftSide ${isOpen == true ? 'active' : ''}`}>
//           <NavLeft isOpen={isOpen} />
//         </div>
//         <main className={`rightSide dark:bg-[#0A0A0A] bg-[#fff] ${isOpen == true ? 'w-[auto]' : '!w-[auto]'}`}>
//           <Outlet context={[isOpen]} />
//         </main>
//       </div>
//     </div>
//   );
// }

// export default App;

import "./App.css";
import NavLeft from "./shades/NavLeft";
import TopBar from "./shades/topBar";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import ScrollToTop from './components/ScrollToTop';
import Intercom from "./components/intercom/Intercom";
import { useSelector, useDispatch } from "react-redux";
import { ExtraCreditsModal } from "./components/PricingPlans/Plans/ExtraCredits";
import { closeExtraCreditsModal, openCreateVideoModal, closeCreateVideoModal } from "./Store/uiSlice";
import CreateVideoModal from "./components/AiModule/CreateVideoModal";
import "./styles/responsive.css";
import { readSession } from "./utils/session";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isExtraCreditsModalOpen = useSelector((state) => state.ui?.isExtraCreditsModalOpen);
  const isCreateVideoModalOpen = useSelector((state) => state.ui?.isCreateVideoModalOpen);
  const initialContentType = useSelector((state) => state.ui?.initialContentType);
  const initialStep = useSelector((state) => state.ui?.initialStep);
  const initialBrandId = useSelector((state) => state.ui?.initialBrandId);

  const [isOpen, setIsopen] = useState(true);
  const ToggleBtn = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  };

  const isBoundedWorkspace = [
    "/videoeditor",
    "/workflow",
    "/marketing",
    "/assets-library",
  ].some((path) => location.pathname.includes(path));

  useEffect(() => {
    if (localStorage.getItem("theme")) {
      if (localStorage.getItem("theme") === "undefined") {
        localStorage.setItem("theme", "light");
      }
    }
    const user = readSession()?.user;
    if (user) {
      Intercom(user);
    }
  }, []);

  useEffect(() => {
    setIsopen(isOpen);
    // const fetchInviteVerification = async() => {
    //   if(token){
    //     try {
    //       const response = await axios.post(`${process.env.REACT_APP_API}team/team-member-invite-verification`,
    //       {
    //         token:token
    //       }
    //       );
    //       localStorage.setItem("settingsToken",token)
    //       navigate('/signup')
    //     } catch (error) {
    //       navigate('/invitationExpired')
    //       // toastify("error", error?.response?.data?.message);
    //     }
    //   }else{
    //     if(!localStorage.getItem('userData') && !localStorage.getItem('token')){
    //       navigate('/');
    //     }
    //   }
    // }
    // fetchInviteVerification();
    if (!localStorage.getItem("userData") && !localStorage.getItem("token")) {
      navigate("/");
    }
  }, [isOpen, navigate]);

  useEffect(() => {
    if (location.state?.openVideoModal) {
      dispatch(openCreateVideoModal({
        type: location.state.type || "image-ads",
        step: location.state.step || "content-type",
        brandId: location.state.brandId || null,
      }));
      // Clean up state
      window.history.replaceState({}, document.title);
    }
  }, [location.state, dispatch]);


  return (
    <div className="app-root">
      <div className="parentDiv sidebarmbl app-shell dark:bg-[#0A0A0A]">
        <TopBar ToggleBtn={ToggleBtn} />
        <div className={`flex pt-[60px] site-wholespace app-shell__body ${isBoundedWorkspace ? "app-shell__body--workbench" : ""}`}>
          <div
            className={`bg-[#FAFAFA] dark:bg-[#111111] pb-4 sidebar leftSide app-shell__sidebar dark:border-r-[0.5px] dark:border-r-[rgb(36,34,34)] ${isOpen ? "active" : ""
              }`}
          >
            <NavLeft isOpen={isOpen} />
          </div>
          <main
            className={`rightSide app-main bg-[#fff] dark:bg-[#0A0A0A] ${isOpen ? "app-main--expanded" : "app-main--collapsed"
              } ${isBoundedWorkspace ? "app-main--workbench" : ""}`}
          >
            <Outlet context={[isOpen]} />
          </main>
          {/* <ScrollToTop /> */}
        </div>
        {/* <div><img className="" src={FloatingMenu} alt="FloatingMenu"/></div> */}
      </div>
      {/* <div className='sidebarmbl-section'>
        <SidebarMbl />
      </div> */}
      <CreateVideoModal
        isOpen={isCreateVideoModalOpen}
        onClose={() => dispatch(closeCreateVideoModal())}
        initialContentType={initialContentType}
        initialStep={initialStep}
        initialBrandId={initialBrandId}
      />
      <ExtraCreditsModal
        isOpen={isExtraCreditsModalOpen}
        onClose={() => dispatch(closeExtraCreditsModal())}
      />
    </div>
  );
}

export default App;
